import { Component, Input } from '@angular/core';
import { RailJourneyLeg } from '@sabstravtech/obtservices/angular';
import { sanitiseDateTime } from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-rail-journey-segments',
  templateUrl: './rail-journey-segments.component.html',
  styleUrl: './rail-journey-segments.component.scss',
  standalone: false
})
export class RailJourneySegmentsComponent {
  @Input() segments: (RailJourneyLeg & { toggleStop: boolean })[] = [];

  removeTimeZone(date: string) {
    return sanitiseDateTime(date);
  }
}
